import React from 'react'
import styled from 'styled-components'

import { Spinner } from '@8x8/oxygen-loaders'

import commonCss from '~/core/css'

const Container = styled.div`
  ${commonCss.flexAllCenter};

  height: 100%;
`

const StyledSpinner = ({ className, size = 'small', style }) => (
  <Container className={className} style={style}>
    <Spinner size={size} />
  </Container>
)

export default StyledSpinner
